import React from "react"

import { type IconProps } from "./utils"

export default function PeopleCircle(props: IconProps) {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 3.33317C6.31818 3.33317 3.33341 6.31794 3.33341 9.99984C3.33341 11.7199 3.98405 13.2872 5.05441 14.4704C6.29963 13.2451 8.01012 12.4998 10.0001 12.4998C11.99 12.4998 13.7005 13.2451 14.9458 14.4704C16.0161 13.2872 16.6667 11.7199 16.6667 9.99984C16.6667 6.31794 13.682 3.33317 10.0001 3.33317ZM13.6764 15.5622C12.7482 14.6967 11.4926 14.1665 10.0001 14.1665C8.50754 14.1665 7.25195 14.6967 6.32374 15.5622C7.37761 16.2604 8.64072 16.6665 10.0001 16.6665C11.3594 16.6665 12.6226 16.2604 13.6764 15.5622ZM1.66675 9.99984C1.66675 5.39746 5.39771 1.6665 10.0001 1.6665C14.6025 1.6665 18.3334 5.39746 18.3334 9.99984C18.3334 12.5195 17.2141 14.7786 15.4486 16.3054C13.9881 17.5684 12.0824 18.3332 10.0001 18.3332C7.91779 18.3332 6.01205 17.5684 4.55161 16.3054C2.78601 14.7786 1.66675 12.5195 1.66675 9.99984ZM10.0001 6.6665C9.07961 6.6665 8.33342 7.4127 8.33342 8.33317C8.33342 9.25365 9.07961 9.99984 10.0001 9.99984C10.9206 9.99984 11.6667 9.25365 11.6667 8.33317C11.6667 7.4127 10.9206 6.6665 10.0001 6.6665ZM6.66675 8.33317C6.66675 6.49222 8.15913 4.99984 10.0001 4.99984C11.841 4.99984 13.3334 6.49222 13.3334 8.33317C13.3334 10.1741 11.841 11.6665 10.0001 11.6665C8.15913 11.6665 6.66675 10.1741 6.66675 8.33317Z"
        fill="currentColor"
      />
    </svg>
  )
}
